import { render, staticRenderFns } from "./FrzDistributionsBoxes.vue?vue&type=template&id=b317d5a8"
import script from "./FrzDistributionsBoxes.vue?vue&type=script&lang=js"
export * from "./FrzDistributionsBoxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports